import { formatDateIso, formatDateMonthDayYear } from "./date-utils";
export function stringifyValue(value, details) {
    if (value === undefined) {
        return "";
    }
    if (details.type === "date" || value instanceof Date) {
        if (details.format === "iso") {
            return formatDateIso(value) || String(value);
        }
        return formatDateMonthDayYear(value) || String(value);
    }
    if (Array.isArray(value)) {
        return value
            .map(v => stringifyValue(v, details))
            .join(details.separator || ",");
    }
    return String(value);
}
//# sourceMappingURL=stringify-value.js.map